import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, styled } from '@mui/material';
var StyledModalContainer = styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'adminModal';
  }
})(function (_ref) {
  var theme = _ref.theme,
      adminModal = _ref.adminModal;

  var styles = _defineProperty({
    padding: adminModal ? '0' : theme.spacing(4),
    borderRadius: theme.typography.pxToRem(12)
  }, theme.breakpoints.down('md'), {
    padding: theme.spacing(3, 2)
  });

  return styles;
});
export { StyledModalContainer };